<template>
	<div>
		<el-dialog v-if="visible" :title="modalTitle" width="800px" :visible.sync="visible" :close-on-click-modal="false">
			<el-card class="box-card" v-if="formData.id">
				<div slot="header" class="clearfix">
					<span>基本信息</span>

				</div>

				<el-form :model="formData" inline :rules="rules" ref="adminUserInfo" label-width="80px">



					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="学生姓名" prop="stu_name">
								<el-input size="small" v-model.trim="formData.stu_name" style="width: 100%"
									placeholder="学生姓名" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="身份证号" prop="identity_card" required>
								<el-input size="small" type="text" v-model.trim="formData.identity_card"
									@change="getBirthdayFromIdCard" placeholder="身份证号" style="width: 100%" />
							</el-form-item>
						</el-col>

					</el-row>


					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="性别" prop="gender">
								<el-radio-group size="small" v-model="formData.gender">
									<el-radio :label="1">男</el-radio>
									<el-radio :label="2">女</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="出生日期" prop="birthday">
								<el-date-picker size="small" v-model="formData.birthday" value-format="yyyy-MM-dd"
									type="date" placeholder="选择日期" style="width:200px">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系方式" prop="phone">
								<el-input size="small" v-model.trim="formData.phone" style="width: 100%"
									placeholder="手机号码" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="考试证号" prop="exam_num">
								<el-input size="small" v-model.trim="formData.exam_num" style="width: 100%"
									placeholder="考试证号" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="中考成绩">
								<el-input size="small" v-model.trim="formData.exam_score" style="width: 100%"
									placeholder="中考成绩" />
							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="一模成绩">
								<el-input size="small" v-model.trim="formData.exam_num" style="width: 100%"
									placeholder="中考一模成绩" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="二模成绩">
								<el-input size="small" v-model.trim="formData.exam_num" style="width: 100%"
									placeholder="中考二模成绩" />
							</el-form-item>
						</el-col>






						<el-col :span="12">
							<el-form-item label="家庭住址" prop="">
								<el-input size="small" v-model.trim="formData.jtzz" style="width: 100%"
									placeholder="家庭住址" />
							</el-form-item>
						</el-col>

					</el-row>


					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="录取性质">
								<el-input size="small" readonly="" v-model.trim="formData.xuezhi || '五年制高职'"
									style="width: 100%" placeholder="从专业中选择" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="第二批次" prop="">
								<el-input @focus="showMajorWin(formData.major_id)" placeholder="请选择专业"
									suffix-icon="el-icon-search" v-model="formData.major_name" size="small"
									style="width: 200px;">
								</el-input>


							</el-form-item>
						</el-col>





					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="录取性质">
								<el-input size="small" readonly="" v-model.trim="formData.xuezhi2 || '“3+3”中高职分段培养'"
									style="width: 100%" placeholder="从专业中选择" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="第二批次" prop="">
								<el-input @focus="showMajorWin(formData.major_id2)" placeholder="请选择专业"
									suffix-icon="el-icon-search" v-model="formData.major_name2" size="small"
									style="width: 200px;">
								</el-input>


							</el-form-item>
						</el-col>





					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="录取性质">
								<el-input size="small" readonly="" v-model.trim="formData.xuezhi3 || '三年中专'"
									style="width: 100%" placeholder="从专业中选择" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="第三批次" prop="">
								<el-input @focus="showMajorWin(formData.major_id3)" placeholder="请选择专业"
									suffix-icon="el-icon-search" v-model="formData.major_name3" size="small"
									style="width: 200px;">
								</el-input>


							</el-form-item>
						</el-col>





					</el-row>


					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="毕业地区" prop="graduate_sch_city" style="width: 100%; display: block;">
								<el-cascader ref="firstCascader" :options="areas" size="small" style="width: 200px;"
									:props="firstCascaderPropsArea" v-model="formData.graduate_dist_code"
									@change="handleCascaderChangeArea" placeholder="请选择" clearable></el-cascader>
							</el-form-item>
						</el-col>



						<el-col :span="12">
							<el-form-item label="毕业学校" prop="graduate_schname" style="width: 100%; display: block;">
								<div class="flexStart" style="width: 100%;">
									<el-input size="small" v-model.trim="formData.graduate_schname"
										@input="$forceUpdate()" style="width: 200px;margin-left: 0px;"
										placeholder="若学校不在选择之列，请自行填写" />

								</div>

							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="监护人1">
								<el-input size="small"  v-model.trim="formData.jhr1name" style="width: 100%"
									placeholder="监护人" />
							</el-form-item>
						</el-col>


						<el-col :span="12">
							<el-form-item label="电话">
								<el-input size="small"  v-model.trim="formData.jhr1phone" style="width: 100%"
									placeholder="电话" />
							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="监护人2">
								<el-input size="small" v-model.trim="formData.jhr2name" style="width: 100%"
									placeholder="监护人" />
							</el-form-item>
						</el-col>


						<el-col :span="12">
							<el-form-item label="电话">
								<el-input size="small"  v-model.trim="formData.jhr2phone" style="width: 100%"
									placeholder="电话" />
							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="推荐老师">
								<el-input size="small"  v-model.trim="formData.otherjson.tjr"
									style="width: 100%" placeholder="推荐老师" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="是否住宿">
								<el-radio-group size="small" v-model="formData.dorm">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="签订协议">
								<el-radio-group size="small" v-model="formData.otherjson.xieyi">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>


					</el-row>

					<el-row :gutter="20">
						<el-col :span="24">

							<el-form-item label="招生咨询" prop="remark" style="width: 100%; display: block;">
								<div class="flexStart" style="width: 100%;">
									<el-input v-model.trim="formData.remark" type="textarea"
										:autosize="{ minRows: 2, maxRows: 6 }" placeholder="备注" style="width: 600px" />

								</div>

							</el-form-item>


						</el-col>
					</el-row>













				</el-form>

			</el-card>





			<!-- <stuImgs :studata="formData" @actions="refreshList"></stuImgs> -->

			<div style="height: 10px;"></div>



			<el-row>
				<div style="float:left;">
					<el-row :gutter="20">
						<el-col :span="24">


							<el-input v-model.trim="formData.sp_word" type="textarea"
								:autosize="{ minRows: 1, maxRows: 6 }" placeholder="审批不通过时请填写不通过原因"
								style="width: 500px" />

						</el-col>
					</el-row>
				</div>
				<div style="float: right;">
					<el-button size="small" type="danger" @click="handleOk('adminUserInfo', -1)">审核不通过</el-button>
					<el-button size="small" type="warning" @click="handleCancel">取消</el-button>
					<el-button size="small" type="primary" @click="handleOk('adminUserInfo', 1)">审核通过</el-button>
				</div>
			</el-row>
		</el-dialog>

		<majors v-if="majorShow" :major_id="major_id" filter_xz='1'></majors>
	</div>
</template>
<script>
import api from '@/api/api';
import majors from './majors.vue'
// import stuImgs from './images.vue'
import area from "../../../../utils/arae_value.js"
export default {
	name: 'Form',
	components: {
		majors,
		// stuImgs
	},
	data() {
		var checkmajor_id = (rule, value, callback) => {
			callback();
		};
		return {
			visible: false,
			majorShow: false,
			formData: {
				status: 0,
				dorm: 0,
				major_id: 0
			},
			rules: {

				// archive: [{
				// 	required: true,
				// 	message: '请输入建档号',
				// 	trigger: 'blur'
				// }, ],
				// exam_num: [{
				// 	required: true,
				// 	message: '请输入考试号',
				// 	trigger: 'blur'
				// }, ],
				stu_name: [{
					required: true,
					message: '请输入姓名',
					trigger: 'blur'
				},],

				gender: [{
					required: true,
					message: '请选择性别',
					trigger: 'blur'
				},],
				major_id: [{
					required: true,
					validator: checkmajor_id,
					trigger: 'blur'
				},],
				exam_score: [{
					required: true,
					message: '请填写中考成绩',
					trigger: 'blur'
				},],
				volunteer: [{
					required: true,
					message: '请选第几志愿',
					trigger: 'blur'
				},],
				graduate_sch_city: [{
					required: true,
					message: '请选择毕业地区',
					trigger: 'blur'
				},],
				graduate_schname: [{
					required: true,
					message: '请填写毕业院校',
					trigger: 'blur'
				},],
				phone: [{
					required: true,
					message: '请填写手机号',
					trigger: 'blur'
				},],
				dorm: [{
					required: true,
					message: '请选择是否住宿',
					trigger: 'blur'
				},],
			},
			firstCascaderProps: {
				label: 'title',
				value: 'id',
				children: 'children',
				emitPath: false,
			},
			firstCascaderPropsArea: {
				children: 'children',
				label: 'label',
				value: 'value',
				emitPath: false,
				checkStrictly: true
			},
			schoolList: [],
			areaScore: {
				score_line: -1,
				plan_score: 0
			},
			hukouData: [],
			areas: [],
			loading: false,
			feeList: [],
			feeGroup: [],
			feeBz: "",
			major_id: "",
			minzuList: "汉族、蒙古族、回族、藏族、维吾尔族、苗族、彝族、壮族、布依族、朝鲜族、满族、侗族、瑶族、白族、土家族、哈尼族、哈萨克族、傣族、黎族、僳僳族、佤族、畲族、高山族、拉祜族、水族、东乡族、纳西族、景颇族、柯尔克孜族、土族、达斡尔族、仫佬族、羌族、布朗族、撒拉族、毛南族、仡佬族、锡伯族、阿昌族、普米族、塔吉克族、怒族、乌孜别克族、俄罗斯族、鄂温克族、德昂族、保安族、裕固族、京族、塔塔尔族、独龙族、鄂伦春族、赫哲族、门巴族、珞巴族、基诺族",

		}
	},
	mounted() {
		this.minzuList = this.minzuList.split("、")
		let hkdata = JSON.parse(JSON.stringify(area))
		for (let p of hkdata) {
			for (let c of p.children) {
				delete c.children
			}
		}
		this.hukouData = hkdata
		this.areas = area
	},
	props: {
		modalTitle: {
			type: String,
			default: '添加学生'
		},
		editOptions: {
			type: Object
		},
		majorList: {
			type: Array,
			default: []
		},
		areaList: {
			type: Array,
			default: []
		},
	},
	methods: {
		showMajorWin(e) {
			this.major_id = e
			this.majorShow = true

		},
		handleOk(formName, status) {
			if (this.loading) {
				return
			}
			if (status) {
				this.formData.status = status
			}
			if(status==1){
				if(!this.formData.identity_card){
					this.$message.error("请输入身份证号")
					return
				}
			}

			this.$emit('saveForm', this.formData)


			setTimeout(() => {
				this.loading = false
			}, 3000)


		},
		handleCancel() {
			// this.$emit('close')
			this.visible = false
		},
		refreshList() {
			console.log("刷新")
			this.$parent.getList()
		},
		show() {
			let formData = Object.assign({}, this.editOptions)
			this.areaScore.score_line = -1
			if (formData.otherjson) {
				formData.otherjson = JSON.parse(formData.otherjson)
				if(!formData.otherjson.xieyi){
					formData.otherjson.xieyi=0;
				}
				formData.pjson = formData.otherjson

			}
			if (!formData.phone && formData.jhr1phone) {
				formData.phone = formData.jhr1phone
			}
			this.formData = formData
			if (formData.graduate_dist_code) {
				this.getSchoolList(formData.graduate_dist_code)
				this.getAreaScore(formData.graduate_dist_code)
			}
			this.getStudentFee(formData.id);
			
			this.visible = true
		},
		handleCascaderChange(e) {
			this.stuForm.hkszd = (this.$refs['hukou'].getCheckedNodes()[0].pathLabels.join(","))
		},
		handleCascaderChangeArea(e) {
			let node = this.$refs['firstCascader'].getCheckedNodes()[0].pathLabels
			this.formData.graduate_sch_city = node.join(',')
			this.getSchoolList(e)
			console.log(e)
			this.getAreaScore(e)

		},
		getSchoolList(id) {
			let _this = this
			this.$http.post(api.areaSchoolList, {
				dist_code: id
			}).then(res => {
				this.schoolList = res.data
			})
		},
		changeSchool(e) {
			let selectName = this.schoolList.find(obj => obj.id == e).school_name
			this.formData.graduate_schname = selectName
		},
		getBirthdayFromIdCard: function (idCard) {
			let _this = this
			let birthday = "";
			if (idCard != null && idCard != "") {
				if (idCard.length == 15) {
					birthday = "19" + idCard.substr(6, 6);
					birthday = `${birthday.substr(0, 4)}-${birthday.substr(4, 2)}-${birthday.substr(6, 2)}`
					this.formData.birthday = birthday
				} else if (idCard.length == 18) {
					birthday = idCard.substr(6, 8);
					birthday = `${birthday.substr(0, 4)}-${birthday.substr(4, 2)}-${birthday.substr(6, 2)}`
					this.formData.birthday = birthday
				}
				this.formData = {
					..._this.formData
				}
			}

		},
		getAreaScore(dist_code) {
				this.$http.post("/api/get_score_line", {
				dist_code: dist_code,
major_id:this.formData.major_id
			}).then(res => {
				if (res.data) {
					this.areaScore = res.data
				}
			})
		},
		closeMajor(item) {

			this.majorShow = false
			if (item) {
				this.formData.major_id = item.id;
				this.formData.major_name = "(" + item.item_num + ")" + item.title;
				this.formData.nianzhi = item.item_desc
				this.formData.yuanxi = item.yuanxi
			} else {
				this.formData.yuanxi = this.formData.yuanxi_name
			}
			//检查是否计算机系


			for (let k in this.feeGroup) {
				if (this.feeGroup[k].list.length > 1) {
					let isThisGroup = false;
					if (this.formData.yuanxi.indexOf("计算机") >= 0) {
						for (let item of this.feeGroup[k].list) {
							if (item.fee_name.indexOf("计算机") >= 0) {

								this.feeGroup[k].ckdid = item.id
								break;

							} else {
								this.feeGroup[k].ckdid = item.id
							}
						}
					} else { //不是计算机，则还原
						for (let item of this.feeGroup[k].list) {
							if (item.fee_name.indexOf("计算机") >= 0) {

							} else {
								this.feeGroup[k].ckdid = item.id
							}
						}
					}
				}
			}
		},

		setZhusu() {
			for (let item of this.feeList) {
				if (this.formData.dorm && item.fee_name.indexOf("住宿") >= 0) {
					item.stu_fee = item.fee_name.split('￥')[1].replace(")", '')
					break
				} else if (!this.formData.dorm && item.fee_name.indexOf("住宿") >= 0) {
					item.stu_fee = 0
					break
				}
			}
		},
		getStudentFee(stu_id) {

			this.$http.post("/api/t_sch_cost_list", {
				stu_id: stu_id
			}).then(res => {
				let fee = [];
				if (res.data.stu) {

					res.data.stu.remark = JSON.parse(res.data.stu.remark)
					this.feeBz = res.data.stu.bz
				}

				let getStuFee = id => {
					let stu_fee = "";
					if (res.data.stu) {
						for (let item of res.data.stu.remark) {
							if (item.id == id) {
								stu_fee = item.stu_fee;
								break;
							}
						}
					}

					return stu_fee
				}

				for (let item of res.data.data) {

					if (item.fee_name.indexOf("住宿") >= 0) {
						fee.push({
							fee_name: item.fee_name + ":(￥" + item.fee_price + ")",
							fee_code: item.fee_code,
							fee_price: this.formData.dorm ? item.fee_price : 0,
							id: item.id,
							stu_fee: getStuFee(item.id)

						})
					} else {

						fee.push({
							fee_name: item.fee_name + ":(￥" + item.fee_price + ")",
							fee_code: item.fee_code,
							fee_price: item.fee_price,
							id: item.id,
							stu_fee: getStuFee(item.id)

						})
					}

				}
				this.feeList = fee
				//分组
				let group_obj = {};

				for (let item of fee) {

					if (item.fee_code) {
						if (!group_obj[item.fee_code]) {
							group_obj[item.fee_code] = {
								ckdid: item.id,
								list: [item]
							}
						} else {
							group_obj[item.fee_code].list.push(item)
							item.stu_fee > 0 ? group_obj[item.fee_code].ckdid = item.id : false
						}

					} else {
						group_obj[item.fee_name] = {
							ckdid: item.id,
							list: [item]
						}
					}
				}
				this.feeGroup = group_obj
				this.closeMajor()


			})
		},
		handleCommand(f) {
			let id = f.split("_")[0];
			let code = f.split("_")[1];
			for (let item of this.feeGroup[code].list) {
				this.feeGroup[code].ckdid = id
			}
		},
		autoWrite() {
			for (let item of this.feeList) {
				if (item.fee_name.indexOf("住宿") >= 0) {
					if (this.formData.dorm) {
						item.stu_fee = item.fee_name.split('￥')[1].replace(")", '')
					} else {
						item.stu_fee = 0;
					}
				} else {
					item.stu_fee = item.fee_name.split('￥')[1].replace(")", '')
				}

			}
		},
		saveStuFee() {

			//先检查费用是否都是数字
			for (let item of this.feeList) {

				if (isNaN(item.stu_fee)) {
					return -1

				}
			}


			let total_money = 0;
			let feeList = [];

			for (let k in this.feeGroup) {
				let fee = this.feeGroup[k]
				for (let item of fee.list) {
					item.stu_fee ? true : item.stu_fee = 0;
					if (fee.ckdid != item.id) {
						item.stu_fee = 0;
					}
					total_money += parseFloat(item.stu_fee);
					feeList.push(item)
				}
			}
			let data = null
			if (total_money >= 0) {

				data = {
					stu_id: 0,
					total_money: total_money,
					bz: this.feeBz,
					remark: JSON.stringify(feeList)
				}




			}

			return data
		},
	}
}
</script>
